import React from 'react'

export const IEWarning = () => {
  return (
    <div className="bg-gray-200 flex items-center justify-center h-screen px-6 fixed inset-0 z-50">
      <div className="bg-white p-10 rounded text-gray-400">
        <h1 className="text-4xl font-sans uppercase font-bold leading-none tracking-widest ">
          Your browser is insecure.
        </h1>
        <p className="mt-3 text-gray-500 text-lg sm:text-2xl lg:text-xl xl:text-2xl leading-normal font-body max-w-xl">
          It looks like you are using an outdated browser with security
          vulnerabilites.
        </p>
        <p className="mt-6 text-gray-500 text-lg sm:text-2xl lg:text-xl xl:text-2xl leading-normal font-body max-w-xl">
          Please use a current web browser to view this website.
        </p>
      </div>
    </div>
  )
}
